module.exports = __webpack_public_path__ + "static/media/evjf.5a069541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/evjf.png
// module id = 2309
// module chunks = 0